export const DataExports = {
  top: {
    id: 'div-gpt-ad-1500407115678-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_DataExports_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1500407034119-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_DataExports_top_320x100',
  },
};



// WEBPACK FOOTER //
// ./modules/DataExports/components/ads.js